/**
 * Domain error codes.
 *
 * The write-rule codes are exactly the machine codes the API returns (§7.4), so the
 * UI branches on one vocabulary whether the check ran in the browser or on the server.
 */

export type WriteViolationCode =
  | 'NA_NOT_CONTEXTUAL'
  | 'EVIDENCE_REQUIRED'
  | 'GAP_NOTE_REQUIRED'
  | 'NA_JUSTIFICATION_REQUIRED'
  | 'WAIVER_NOT_APPROVED'
  | 'RECORDED_VALUE_REQUIRED';

export interface WriteViolation {
  readonly code: WriteViolationCode;
  /** Human-readable and shown as-is (§7.4) — not a toast saying "Error". */
  readonly message: string;
  readonly itemRef: string;
}

/** Thrown for programming errors — bad expression source, impossible state combination. */
export class DomainError extends Error {
  readonly code: string;

  constructor(code: string, message: string) {
    super(message);
    this.name = 'DomainError';
    this.code = code;
  }
}

export class ContextExpressionError extends DomainError {
  readonly source: string;
  readonly position: number;

  constructor(message: string, source: string, position: number) {
    super('CONTEXT_EXPRESSION_INVALID', `${message} (in "${source}" at position ${position})`);
    this.name = 'ContextExpressionError';
    this.source = source;
    this.position = position;
  }
}
